import { render, staticRenderFns } from "./SfBar.vue?vue&type=template&id=79909bf1&"
import script from "./SfBar.vue?vue&type=script&lang=ts&"
export * from "./SfBar.vue?vue&type=script&lang=ts&"
import style0 from "./SfBar.vue?vue&type=style&index=0&id=79909bf1&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports